import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  extendedFields: {
    get: async (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { category, entityId } = params;
          const { data, status } = await versionedHttpCollection.get(
            "entityservice",
            `entity/extendedfields?category=${category}&entityid=${entityId}`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    save: async (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { category, request } = params;
          const { data, status } = await versionedHttpCollection.post(
            "entityservice",
            `entity/extendedfield/${category}`,
            request,
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: async (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { category, itemId } = params;
          const { data, status } = await versionedHttpCollection.delete(
            "entityservice",
            `extendedfield/${category}`,
            itemId,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    getMetaData: async (): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "entityservice",
            `debtor/otherinfometadata`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
